import React, { createContext, useContext, useReducer, useMemo } from "react";
import { InitialState } from "./InitialState";
import { initialState, reducer } from "./reducer";
export { reducer } from "./reducer";

export const SocketProvider: any = (props: any) => {
  const { children } = props;
  const [state, dispatch] = useReducer(reducer, initialState);

  const appContextValue = useMemo(
    () => ({ state, dispatch }),
    [state, dispatch],
  );

  return (
    <AppContext.Provider value={appContextValue}>
      {children}
    </AppContext.Provider>
  );
};

export const AppContext = createContext<{
  state: InitialState;
  dispatch: any;
}>(SocketProvider);

export const useAuth = () => useContext(AppContext);
